import React from 'react';
import { Button } from './ui/button';

const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-end md:items-center overflow-hidden">
      {/* Background Image - Repositioned to show face */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://customer-assets.emergentagent.com/job_c8ba1316-fe9a-4786-bbb1-586136be868e/artifacts/38oatjps_Elegance%20By%20AG-2570.jpg"
          alt="Wanda Roman"
          className="w-full h-full object-cover object-[center_35%] md:object-[65%_35%]"
        />
        <div className="absolute inset-0 bg-gradient-to-t md:bg-gradient-to-r from-purple-900/90 via-purple-800/60 to-transparent"></div>
      </div>

      {/* Content - Positioned to not overlap face */}
      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 pb-16 md:pb-20 md:py-32">
        <div className="max-w-3xl">
          <div className="space-y-4 md:space-y-6 animate-in fade-in slide-in-from-bottom duration-1000">
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-bold text-white leading-tight">
              Wanda Roman
            </h1>
            <div className="space-y-2 md:space-y-3">
              <p className="text-lg sm:text-xl md:text-2xl lg:text-3xl text-white/95 font-medium">
                Candidate for City of Kissimmee Commissioner
              </p>
              <p className="text-xl sm:text-2xl md:text-3xl lg:text-4xl text-amber-300 font-bold tracking-wide">
                Seat 2
              </p>
            </div>
            <p className="text-xl sm:text-2xl md:text-3xl lg:text-4xl text-white font-semibold italic pt-2 md:pt-4">
              "Leadership. Community. Progress."
            </p>
            <div className="flex flex-col sm:flex-row gap-3 md:gap-4 pt-6 md:pt-8">
              <a
                href="https://square.link/u/PPzV8yyu"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center bg-amber-500 hover:bg-amber-600 text-purple-900 font-bold text-base md:text-lg px-6 md:px-8 py-5 md:py-6 rounded-lg shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105"
              >
                Donate Now
              </a>
              <Button
                onClick={() => scrollToSection('get-involved')}
                size="lg"
                variant="outline"
                className="bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white border-2 border-white font-bold text-base md:text-lg px-6 md:px-8 py-5 md:py-6 shadow-xl transition-all duration-300 hover:scale-105"
              >
                Get Involved
              </Button>
              <Button
                onClick={() => scrollToSection('about')}
                size="lg"
                variant="outline"
                className="bg-white/10 backdrop-blur-sm hover:bg-white/20 text-white border-2 border-white font-bold text-base md:text-lg px-6 md:px-8 py-5 md:py-6 shadow-xl transition-all duration-300 hover:scale-105"
              >
                Meet Wanda
              </Button>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce hidden md:block">
        <div className="w-6 h-10 border-2 border-white rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-3 bg-white rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
